import * as React from 'react'
import { ContextRoute } from './app/context'
import { ServiceType } from './domain/ServiceType'
import Link from './helper/link'
import { WithEnvironmentAndService } from './helper/WithEnvironmentAndService'
import ServiceEnvironmentIndicator from './history/service-environment-indicator'
import { Col, Row } from './ui/grid'
import moment from 'moment'

export interface NavigationEntry {
    label: string
    type: ServiceType
    route: string
}

interface Props {
    navigationEntries: NavigationEntry[]
    currentRoute: ContextRoute
    showAddMarkerButton: boolean
}

export class ServiceTypeNavigation extends React.Component<Props> {
    public static defaultProps = {
        showAddMarkerButton: false,
    }

    public render() {
        const navigationEntries = this.props.navigationEntries
        const currentRoute = this.props.currentRoute
        const serviceType = currentRoute.parameters.st || ServiceType.php
        const rangeTime = moment
            .utc(currentRoute.parameters.date)
            .local()
            .format('HH:mm')

        return (
            <Row>
                <Col width={8}>
                    <ul className="nav nav-pills nav-pills-tideways">
                        <li style={{ padding: '8px 16px' }}>
                            <WithEnvironmentAndService
                                render={({ service, environment }) => (
                                    <ServiceEnvironmentIndicator service={service} environment={environment} />
                                )}
                            />
                        </li>
                        {navigationEntries.map(entry => (
                            <li className={entry.type === serviceType ? 'active' : ''} key={entry.type}>
                                <Link
                                    route={entry.route}
                                    params={{ st: entry.type, date: currentRoute.parameters.date, end: currentRoute.parameters.end }}
                                >
                                    {entry.label}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </Col>
                <Col width={4}>
                    <div className="btn-group pull-right">
                        {this.props.showAddMarkerButton ? (
                            <>
                                <Link
                                    className="btn btn-default"
                                    route="XhprofProfilerBundle.Event.createFormAction"
                                    params={{ type: 'release' }}
                                    query={{ date: currentRoute.parameters.date }}
                                    skipHistoryApi
                                >
                                    Add Release at {rangeTime}
                                </Link>
                                <Link
                                    className="btn btn-default"
                                    route="XhprofProfilerBundle.Event.createFormAction"
                                    params={{ type: 'marker' }}
                                    query={{ date: currentRoute.parameters.date }}
                                    skipHistoryApi
                                >
                                    Add Marker at {rangeTime}
                                </Link>
                            </>
                        ) : null}
                    </div>
                </Col>
            </Row>
        )
    }
}
